import { useEffect, useState } from 'react'
import { CartType } from '@whatsmenu/entities/dist/cart'
import Profile, { ProfileType } from '@whatsmenu/entities/dist/profile'
import { useSession } from 'next-auth/react'
import type { ChangeHistory } from 'src/context/app.ctx'

export type RunMessageType =
  | 'message_start'
  | 'message_on_the_way'
  | 'message_arriving_on_location'
  | 'message_arrived_on_location'

export const useWhatsAppBot = () => {
  const [canUseWhatsMenuDesktop, setCanUseWhatsMenuDesktop] = useState(false)
  const { data: session, status } = useSession()

  const sendMessage = (contact: string, message: string) => {
    if ('WhatsAppBotApi' in window) {
      ; (window.WhatsAppBotApi as any).sendMessage(contact, message)
    }
  }

  const sendCashbackMessage = (client: string, voucher: any, type: string) => {
    if ('WhatsAppBotApi' in window && (window.WhatsAppBotApi as any).sendCashbackMessage) {
      ; (window.WhatsAppBotApi as any).sendCashbackMessage(client, voucher, type)
    }
  }

  const sendMessageFromRun = async (
    message: string,
    number: string,
    payload: { type: RunMessageType; cartId: number }
  ) => {
    if ('WhatsAppBotApi' in window && (window.WhatsAppBotApi as any).sendMessageFromRun) {
      await (window.WhatsAppBotApi as any).sendMessageFromRun(message, number, payload)
    }
  }

  const storeProfile = (profile: ProfileType | Profile) => {
    if ('DesktopApi' in window) {
      if (
        profile instanceof Profile ||
        Object.values(profile).some((value) => typeof value === 'function')
      ) {
        profile = JSON.parse(JSON.stringify(profile))
      }
      ; (window.DesktopApi as any).storeProfile(profile)
    }
  }

  /**
   * Define as configurações do usuário no Desktop.
   *
   * @param {any} userControls - As configura es do usu rio.
   * @return {void}
   */
  const setUserControls = (userControls: any) => {
    if ('DesktopApi' in window && (window.DesktopApi as any).setUserControls) {
      ; (window.DesktopApi as any).setUserControls(userControls)
    }
  }

  const onMessageSend = (callback: (args: any) => void) => {
    if ('WhatsAppBotApi' in window) {
      ; (window.WhatsAppBotApi as any)?.onmessagesend((_: any, client: any) => {
        callback(client)
      })
    }
  }

  const cartDistance = (
    cartId: CartType['id'],
    cartClient: CartType['client'],
    changeHistory: ChangeHistory | null | undefined,
    distance: number
  ) => {
    if ('DesktopApi' in window) {
      ;(window.DesktopApi as any)?.cartDistance(cartId, cartClient, changeHistory, distance)
    }
  }

  const onCart = (cart: CartType) => {
    if ('DesktopApi' in window) {
      ; (window.DesktopApi as any)?.onCart(cart)
    }
  }

  /**
   * Abre um link no navegador padrão.
   *
   * @param {React.MouseEvent<LinkProps, MouseEvent>} link - O link a ser aberto.
   * @return {void}
   */
  const openLink = (
    event: React.MouseEvent<HTMLAnchorElement, MouseEvent>
  ): void => {
    if ('DesktopApi' in window) {
      event.preventDefault()
        ; (window.DesktopApi as any)?.openLink(event.currentTarget.href)
    }
  }

  useEffect(() => {
    if ('navigator' in window) {
      setCanUseWhatsMenuDesktop(navigator.userAgent.includes('Windows NT 10'))
    }
  }, [])

  useEffect(() => {
    if (status === 'authenticated' && 'DesktopApi' in window) {
      setUserControls(session.user?.controls)
    }
  }, [status, session])

  return {
    sendMessage,
    sendCashbackMessage,
    storeProfile,
    setUserControls,
    onMessageSend,
    onCart,
    cartDistance,
    openLink,
    canUseWhatsMenuDesktop,
    sendMessageFromRun,
  }
}
